import axiosIns from "@/api/axios";


export const getListFieldApprovalKTT = async (params) => {
    const { token } = params;
    try {
        const response = await axiosIns.get(`/common/tna/list-training?token=${token}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching field approval KTT:', error);
        throw error;
    }
}

export const getUniqueCompetencies = async (params = {}) => {
    const { token, company } = params;
    try {
        const queryParams = {
            token,
        };
        
        if (company) {
            queryParams.company = company;
        }
        
        const response = await axiosIns.get('/common/tna/unique-competencies', {
            params: queryParams
        });

        return response.data;
    } catch (error) {
        console.error('Error fetching unique competencies:', error);
        throw error;
    }
}

export const getListApprovalKTT = async (params) => {
    const { token, page = 1, limit = 10, company, all = false } = params;
    try {
        const queryParams = {
            token,
            page,
            pageSize: limit,
        };

        if (all) {
            queryParams.all = true;
        }
        
        if (company) {
            queryParams.company = company;
        }
        
        const response = await axiosIns.get('/common/tna/submitted-learnings', {
            params: queryParams
        });

        return response.data;
    } catch (error) {
        console.error('Error fetching approval KTT:', error);
        throw error;
    }
}

export const getAvailableCompanies = async (params) => {
    const { token } = params;
    try {
        const response = await axiosIns.get('/common/tna/available-companies', {
            params: {
                token,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching available companies:', error);
        throw error;
    }
}

export const approveTNAByKTT = async (params) => {
    const { token, ids = [] } = params;
    try {
        const response = await axiosIns.post('/common/tna/ktt/approve', {
            ids,
        }, {
            params: {
                token,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error approving TNA by KTT:', error);
        throw error;
    }
}

export const rejectTNAByKTT = async (params) => {
    const { token, ids = [], reason = '' } = params;
    try {
        const response = await axiosIns.post('/common/tna/ktt/reject', {
            ids,
            reason,
        }, {
            params: {
                token,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error rejecting TNA by KTT:', error);
        throw error;
    }
}
